import React from "react";
import { Container, Row, Table, Button, Col } from "react-bootstrap";
import { DraggableTable } from "presentation/components/draggable-table/table";
import { TableStyles } from "presentation/components/draggable-table/table-styles";

import PageLoadingIndicator from "presentation/components/page-loading-indicator";
import PageAlert from "presentation/components/page-alert";
import PageModal from "presentation/components/page-modal";

import AddButton from "presentation/components/buttons/add";

import ManageStageCriteriaModal from "presentation/pages/evaluation-schemes/elements/manage-stage-criteria-modal";

import DropdownMenu from "presentation/components/dropdown-menu/menu";
import EditItemTitle from "presentation/components/dropdown-menu/item-title/edit";
import RemoveItemTitle from "presentation/components/dropdown-menu/item-title/remove";
import { DROPDOWN_MENU_TYPE_ITEM } from 'presentation/model/constants';

import {
    arrayMove
} from "@dnd-kit/sortable";
import { isNullOrEmpty } from "presentation/utils/functions/generic";

class StageCriteriasTabEvaluationSchemeForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            actionLoading: false,
            error: false,
            message: '',
            data: [],
            showConfirmModal: false,
            showManageStageCriteriaModal: false,
            targetDeleteId: null,
            draggableTableData: [],
            stageCriteriaKey: null,
            stageCriteria: {},
            stageCriteriaId: null
        };
        this.closeModal = this.closeModal.bind(this);
        this.deleteItem = this.deleteItem.bind(this);
        this.makeData = this.makeData.bind(this);
    }

    componentDidMount() {
        this.makeData();
    }

    openModal = (id) => {
        this.setState({ targetDeleteId: id, showConfirmModal: true });
    }

    closeModal = () => {
        this.setState({ showConfirmModal: false, targetDeleteId: null });
    }

    openManageStageCriteriaModal = (stageCriteria = {}, stageCriteriaId = null, stageCriteriaKey = null) => {
        this.setState({ showManageStageCriteriaModal: true, stageCriteria: stageCriteria, stageCriteriaId: stageCriteriaId, stageCriteriaKey: stageCriteriaKey });
    }

    closeManageStageCriteriaModal = () => {
        this.setState({ showManageStageCriteriaModal: false, stageCriteria: {}, stageCriteriaId: null, stageCriteriaKey: null });
    }

    deleteItem = () => {
        let me = this;
        let { component } = me.props;
        let { stageCriterias } = component.state;
        let { targetDeleteId } = me.state;
        let { makeData } = me;

        if (targetDeleteId) {
            let target = stageCriterias.filter(x => x.id == targetDeleteId)[0];

            target.isDeleteRequested = true;

            let others = stageCriterias.filter(x => x.id != targetDeleteId);
            let newValues = [];

            if (target.id && !target.isVirtualId) {
                newValues = [...others, target];
            } else {
                newValues = [...others];
            }


            component.setState(
                { stageCriterias: newValues }, () => {
                    makeData();
                    me.setState({ targetDeleteId: null, showConfirmModal: false });
                });
        }
    }

    makeData = () => {
        let { openModal, openManageStageCriteriaModal } = this;
        let { component } = this.props;
        let { stageCriterias, stages } = component.state;

        var validOptions = stageCriterias.filter(x => !(x.isDeleteRequested == true)).sort((a, b) => a.weight - b.weight);

        var data = validOptions.map((e, i) => {
            let stageCriteriaStage = stages.filter(x => x.id == e.stageId)[0];
            var id = e.id;

            e.rowOrder = "";
            let criteria = `Se a média for >= a ${e.neededScore}`;
            e.rowStageName = (<div className="table-cell-height-limited">{stageCriteriaStage?.name}</div>);
            e.rowStageCriteriaName = (<div className="table-cell-height-limited">{criteria}</div>);
            e.rowActions = (
                <DropdownMenu
                    items={[
                        { type: DROPDOWN_MENU_TYPE_ITEM, title: <EditItemTitle />, props: { onClick: () => openManageStageCriteriaModal(e, id, e.key) } },
                        { type: DROPDOWN_MENU_TYPE_ITEM, title: <RemoveItemTitle />, props: { onClick: () => openModal(id) } }
                    ]}
                />);

            return e;
        });
        this.setState({ draggableTableData: data });
    };

    setData = (event) => {
        const { active, over } = event;
        let { component } = this.props;
        const { stageCriterias } = component.state;

        const { draggableTableData } = this.state;

        const items = draggableTableData?.map(({ id }) => id);

        if (active.id !== over.id) {

            const oldIndex = items.indexOf(active.id);
            const newIndex = items.indexOf(over.id);
            let reorderedData = arrayMove(draggableTableData, oldIndex, newIndex);

            let ordersDisctionary = [];

            reorderedData.map((e, i) => {
                e.weight = i;
                ordersDisctionary.push({ stageCriteriaId: e.id, weight: i });
                return e;
            });

            stageCriterias.map((q, i) => {
                let weight = ordersDisctionary.filter(x => x.stageCriteriaId == q.id)[0]?.weight;
                q.weight = weight;
                return q;
            });

            component.setState({ stageCriterias: stageCriterias }, () => { this.setState({ draggableTableData: reorderedData }) });


        }
    };


    render() {
        const { loading, actionLoading, error, message, showConfirmModal, showManageStageCriteriaModal, draggableTableData, stageCriteria, stageCriteriaKey, stageCriteriaId } = this.state;

        const { deleteItem, closeModal, openManageStageCriteriaModal, closeManageStageCriteriaModal, setData, makeData } = this;

        let { component, stages, stageCriterias, evaluationTypes } = this.props;

        let { totalStageCriteriaItems } = this.props;

        const validStages = stages.filter(x => x.name && !isNullOrEmpty(x.name) && !(x.isDeleteRequested && x.isDeleteRequested == true));
        const validStageCriterias = stageCriterias.filter(x => x.name && !isNullOrEmpty(x.name) && !(x.isDeleteRequested && x.isDeleteRequested == true));
        let nextStageCriteriaKey = totalStageCriteriaItems + 1;
        let mode = stageCriteria.id ? "edit" : "add";

        const headers = [
            { Header: "#", accessor: "rowOrder", style: { width: "10%", textAlign: "center" } },
            { Header: "Etapa", accessor: "rowStageName", style: { width: "25%" } },
            { Header: "Critério", accessor: "rowStageCriteriaName", style: { width: "60%" } },
            { Header: "Ações", accessor: "rowActions", style: { width: "5%" } }
        ];

        return (
            <div>
                {loading === true && <PageLoadingIndicator loadingText={actionLoading ? "Por favor, aguarde..." : "Carregando informações..."} />}
                {loading === false && error === true && <PageAlert className="m-b-20" message={"Erro"} description={message} type="danger" />}
                {loading === false && error === false && draggableTableData.length <= 0 && <PageAlert className="m-b-20" message={"Sem informações"} description={"Não há dados para exibir no momento..."} type="info" dismissible />}
                {loading === false && (
                    <Container>
                        <Row>
                            <Col size={4} className="mt-4">
                                <AddButton
                                    containerProps={{
                                        onClick: () => openManageStageCriteriaModal(),
                                        disabled: validStages.length < 1
                                    }}

                                />
                            </Col>
                            <Container>
                                <h6 className="float-end mt-4 mb-4">Total de critérios: {draggableTableData.length || 0}</h6>
                                <TableStyles>
                                    <DraggableTable columns={headers} data={draggableTableData} setData={setData} />
                                </TableStyles>
                            </Container>
                        </Row>
                        <ManageStageCriteriaModal
                            show={showManageStageCriteriaModal}
                            afterSubmit={makeData}
                            onClose={closeManageStageCriteriaModal}
                            component={component}
                            stages={validStages}
                            evaluationTypes={evaluationTypes}
                            stageCriterias={validStageCriterias}
                            stageCriteriaKey={stageCriteriaKey != null ? stageCriteriaKey : nextStageCriteriaKey}
                            stageCriteriaId={stageCriteriaId}
                            stageCriteria={stageCriteria}
                            mode={mode}
                        />
                        <PageModal
                            show={showConfirmModal}
                            onClose={closeModal}
                            onConfirm={deleteItem} />
                    </Container>
                )}
            </div>
        );
    };
}

export default StageCriteriasTabEvaluationSchemeForm;


